import { FC, useEffect, useRef } from 'react';

import { ProductsCarouselSliderOneBlockSkeleton as ProductsCarouselSliderOneBlockSkeletonV3 } from '~/components/isolated/CategoryBlocks/ProductsCarouselSliderOneBlock';

interface ScrollPaginationSkeletonProps {
  onLoadMore(): void;
  className?: string;
}

export const ScrollPaginationSkeleton: FC<ScrollPaginationSkeletonProps> = ({
  onLoadMore,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            onLoadMore();
          }
        });
      },
      { rootMargin: `${window.innerHeight}px` },
    );

    // FIXME
    setTimeout(() => {
      ref.current && observer.observe(ref.current);
    }, 2000);

    return () => observer.disconnect();
  }, [onLoadMore]);

  return (
    <ProductsCarouselSliderOneBlockSkeletonV3 ref={ref} className={className} />
  );
};
